import FieldTypeEnum from "@/enums/fields/FieldTypeEnum";
import BaseField from "./BaseField";

/** Noeud de graphique */
export default class GraphNode<T = any> extends BaseField {
	/**
	 * Constructeur avec paramètres
	 * @param id		Identifiant du noeud
	 * @param inputs	Liste des ports entrants sur le noeud
	 * @param outputs	Liste des ports sortants sur le noeud
	 * @param column	Numéro de la colonne dans laquelle est rangée le noeud
	 * @param value		Valeurs complémentaires stockées sur le noeud
	 */
	public constructor();
	public constructor(id: string, inputs: string[], outputs: string[], column: number);
	public constructor(id: string, inputs: string[], outputs: string[], column: number, value: any);
	public constructor(id: string = "", inputs: string[] = [], outputs: string[] = [], column: number = 0, value: any = undefined) {
		super(FieldTypeEnum.Node);

        this.Id = id;
        this.Inputs = inputs;
        this.Outputs = outputs;
        this.Column = column;
        this.Value = value;
	}

	/** Identifiant du noeud */
	public Id: string;

	/** Liste des ports entrants sur le noeud */
	public Inputs: string[];

	/** Liste des ports sortants sur le noeud */
	public Outputs: string[];

	/** Numéro de la colonne dans laquelle est rangée le noeud */
	public Column: number

	/** Valeurs complémentaires stockées sur le noeud */
	public Value: T;
}